import * as yup from 'yup';

export const AddLeaveValidation = yup.object().shape({
  type: yup.object().required('Required').nullable(),
  date: yup.object().required('Required').nullable()
});
